'use strict';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import pickBy from 'lodash/pickBy';
import {
  initLastAccessedOrganizations,
  initLastAccessedProjects,
  initLastAccessedAssets,
  addToLastAccessedOrganizations,
  addToLastAccessedProjects,
  addToLastAccessedAssets,
  removeFromLastAccessedOrganizations,
  removeFromLastAccessedProjects,
  removeFromLastAccessedAssets,
} from '../actions';

const MAX_LATEST = 5;

export function initialOrgState() {
  return [];
}

export function initialOrgChildState() {
  return {};
}

export function lastAccessedOrganizations(state = initialOrgState(), action) {
  switch (action.type) {
    case initLastAccessedOrganizations.TYPE:
      return action.payload.state;
    case addToLastAccessedOrganizations.TYPE:
      return insertReducer(state, action.payload.data);
    case removeFromLastAccessedOrganizations.TYPE:
      return removeReducer(state, action.payload.data);
    default:
      return state;
  }
}

export function lastAccessedProjects(state = initialOrgChildState(), action) {
  switch (action.type) {
    case initLastAccessedProjects.TYPE:
      return action.payload.state;
    case addToLastAccessedProjects.TYPE:
      return addToOrg(state, action.payload);
    case removeFromLastAccessedProjects.TYPE:
      return removeFromOrg(state, action.payload);
    default:
      return state;
  }
}

export function lastAccessedAssets(state = initialOrgChildState(), action) {
  switch (action.type) {
    case initLastAccessedAssets.TYPE:
      return action.payload.state;
    case addToLastAccessedAssets.TYPE:
      return addToOrg(state, action.payload);
    case removeFromLastAccessedAssets.TYPE:
      return removeFromOrg(state, action.payload);
    default:
      return state;
  }
}

/**
 *
 * @param {Object} state
 * @param {Object} payload
 * @param {String} payload.orgId
 * @param {?LastAccessedItem} payload.data
 *
 */
function addToOrg(state, payload) {
  return {
    ...state,
    [payload.orgId]: insertReducer(state[payload.orgId], payload.data),
  };
}

/**
 *
 * @param {Object} state
 * @param {Object} payload
 * @param {String} payload.orgId
 * @param {String} payload.id
 *
 */
function removeFromOrg(state, payload) {
  return {
    ...state,
    [payload.orgId]: removeReducer(state[payload.orgId], payload.id),
  };
}

/**
 *
 * @param {Array.<LastAccessedItem>} list
 * @param {?LastAccessedItem} data
 */
function insertReducer(list = [], data) {
  if (data === null) {
    const result = list.filter((it) => it !== null);
    result.unshift(null);
    return limit(result);
  } else {
    const result = list.filter((it) => it ? it.id !== data.id : false);
    result.unshift(data);
    return limit(result);
  }
}

/**
 *
 * @param {Array.<LastAccessedItem>} list
 * @param {String} id
 */
function removeReducer(list = [], id) {
  return list.filter((it) => it ? it.id !== id : true);
}

function limit(list) {
  if (list.length > MAX_LATEST) {
    return list.slice(0, MAX_LATEST);
  } else {
    return list;
  }
}

/**
 * Validates a last-accessed cache
 * @param cache
 * @return {*}
 */
export function getValidCache(cache) {
  if (!isObject(cache)) {
    return {};
  } else {
    return pickBy(cache, validateCachedList);
  }
}

export function getValidOrgCache(cache) {
  return validateCachedList(cache) ? cache : [];
}

/**
 * Returns true if the input is invalid.
 * @param list
 * @return {boolean}
 */
function validateCachedList(list) {
  return isArray(list) && list.filter(validCachedItem).length > 0;
}

/**
 * Returns true if the input is invalid.
 * @param item
 * @return {boolean}
 */
function validCachedItem(item) {
  return isObject(item) && isString(item.id) && isString(item.label);
}



// WEBPACK FOOTER //
// ./src/js/app/model/reducers/lastAccessed.js